import { render, staticRenderFns } from "./dicAdd.vue?vue&type=template&id=4003d946&"
import script from "./dicAdd.vue?vue&type=script&lang=js&"
export * from "./dicAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports